// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TicketVm from "../../vm-mapper/TicketVm.bs.js";
import * as Caml_array from "../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as IssueBriefCmp from "./IssueBriefCmp.bs.js";
import * as RecordsWrapper from "../../../../order-dashboard/view/components/non-live-order-dashboard/components/RecordsWrapper.bs.js";
import * as TicketCaseComments from "./TicketCaseComments.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as CardComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardComponent.bs.js";
import * as TicketDashboardAssetsManager from "../../assets/TicketDashboardAssetsManager.bs.js";

function TicketRightSection$IssueComment(Props) {
  var comments = Props.comments;
  return React.createElement(CardComponent$Catalyst.make, {
              title: "Issue Comment",
              className: "info-card",
              children: React.createElement(RecordsWrapper.make, {
                    children: React.createElement("div", {
                          className: "record"
                        }, Belt_Option.getWithDefault(comments.issue_comment, "--"))
                  })
            });
}

var IssueComment = {
  make: TicketRightSection$IssueComment
};

function TicketRightSection$ActionComment(Props) {
  var comments = Props.comments;
  return React.createElement(CardComponent$Catalyst.make, {
              title: "Action Comment",
              className: "info-card",
              children: React.createElement(RecordsWrapper.make, {
                    children: React.createElement("div", {
                          className: "record"
                        }, Belt_Option.getWithDefault(comments.action_comment, "--"))
                  })
            });
}

var ActionComment = {
  make: TicketRightSection$ActionComment
};

var comments_icon = TicketDashboardAssetsManager.getImage("comments.svg");

function TicketRightSection$TicketComments(Props) {
  var ticket = Props.ticket;
  var constructAuthorNamefromEmail = function (email) {
    if (email !== undefined) {
      return Belt_Option.mapWithDefault(Caml_array.get(email.split(/[@ ]+/), 0), email, (function (a) {
                    return a.replace(".", " ");
                  }));
    } else {
      return "N/A";
    }
  };
  var match = TicketVm.getVm(ticket);
  var comments = match.comments;
  return React.createElement("div", {
              className: "primary-card ticket-comment primary-info-card"
            }, React.createElement("div", {
                  className: "header"
                }, React.createElement("p", {
                      className: "title"
                    }, constructAuthorNamefromEmail(ticket.author), React.createElement("span", undefined, Timestamp$Catalyst.toString(ticket.raised_at, "DD/MM/YY h:mm a")))), React.createElement(TicketRightSection$IssueComment, {
                  comments: comments
                }), React.createElement(TicketRightSection$ActionComment, {
                  comments: comments
                }));
}

var TicketComments = {
  comments_icon: comments_icon,
  make: TicketRightSection$TicketComments
};

function TicketRightSection(Props) {
  var ticket = Props.ticket;
  var match = TicketVm.getVm(ticket);
  var issue_brief = match.issue_brief;
  return React.createElement("div", {
              className: "c-ticket-right-section"
            }, issue_brief !== undefined ? React.createElement(IssueBriefCmp.make, {
                    issue_brief: issue_brief
                  }) : null, React.createElement(TicketRightSection$TicketComments, {
                  ticket: ticket
                }), React.createElement(TicketCaseComments.make, {
                  comments: match.case_comments.comments
                }));
}

var make = TicketRightSection;

export {
  IssueComment ,
  ActionComment ,
  TicketComments ,
  make ,
  
}
/* comments_icon Not a pure module */
